import { Form, Input, message, Select } from "antd";
import { BaseModal } from "./base.modal";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useBaseQuery } from "hooks/query.hook";
import { apiRoutes } from "api/data/routes";
export const WithdrawalModal = ({ methods, onClose }: any) => {
  const { t } = useTranslation("balance");
  const [form] = Form.useForm();

  const [status, setStatus] = useState<any>("OPEN");

  const { error, isLoading, post, data } = useBaseQuery(
    `${apiRoutes.ACCOUNT_WITHDRAWAL_INITIATE}`
  );
  const onSubmit = async (values: any) => {
    await post(values);
  };

  useEffect(() => {
    if (error) {
      message.error(error || t("somethingWentWrong"));
    }
  }, [error]);

  useEffect(() => {
    if (data) {
      message.success(t("withdrawalSuccess"));
      onClose && onClose(true);
      setStatus("CLOSE");
    }
  }, [data]);
  return (
    <BaseModal
      title={t("withdraw.title")}
      subTitle={t("withdraw.subTitle")}
      confirmLoading={isLoading}
      onOk={() => form.submit()}
      status={status}
    >
      <Form
        className="paylink-form"
        name="signup-form"
        form={form}
        requiredMark={false}
        onFinish={onSubmit}
        layout="vertical"
      >
        <Form.Item
          name="withdrawMethodId"
          label={t("withdraw.fields.method")}
          rules={[{ required: true, message: "" }]}
        >
          <Select
            size="large"
            options={methods.map((item: any) => {
              return {
                label: (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={`assets/${(
                        item?.provider || item?.ejaraCode
                      )?.toLowerCase()}.png`}
                      alt="icon"
                      width={15}
                      style={{ marginRight: 7 }}
                    />
                    <h3 style={{ alignSelf: "center" }} className="truncate">{`${
                      item?.provider || item?.ejaraCode
                    } - ${item?.phoneNumber || item?.cryptoAddress}`}</h3>
                  </div>
                ),
                value: item.id,
              };
            })}
          />
        </Form.Item>

        <Form.Item
          name="amount"
          label={t("withdraw.fields.amount")}
          rules={[{ required: true, message: "" }]}
        >
          <Input size="large" type="number" />
        </Form.Item>
      </Form>
    </BaseModal>
  );
};
